import React, { useEffect, useState } from "react";
import { httpGet, httpPost } from "../../components/helpers/httpMethods";
import "./claimOffer.css";

// /o/CODE from a share link, or /o to type a gift card. Adds credit to the reader's wallet.
const naira = (n) => `₦${Math.round(Number(n) || 0).toLocaleString("en-NG")}`;
const day = (d) => new Date(d).toLocaleDateString("en-GB", { timeZone: "Africa/Lagos", day: "numeric", month: "long" });
const errorOf = (r, fallback) => (r && r.er && r.er.message) || (r && r.success === false && r.message) || fallback;

export default function ClaimOffer({ match, history }) {
  const fromLink = (match && match.params && match.params.code) || "";
  const signedIn = Boolean(localStorage.getItem("token"));
  const [code, setCode] = useState(fromLink);
  const [offer, setOffer] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);

  useEffect(() => {
    if (!fromLink) return;
    httpGet(`offers/look/${encodeURIComponent(fromLink)}`).then((r) => {
      if (r && r.data && r.data.value) setOffer(r.data);
      else setError(errorOf(r, "We don’t recognise that code. Check it and try again."));
    });
  }, [fromLink]);

  const next = encodeURIComponent(`/o/${encodeURIComponent(code.trim() || fromLink)}`);
  const claim = async (e) => {
    if (e) e.preventDefault();
    if (!code.trim() || busy) return;
    if (!signedIn) { history.push(`/login?next=${next}`); return; }
    setBusy(true); setError("");
    const r = await httpPost("offers/redeem", { code: code.trim() });
    setBusy(false);
    if (r && r.data && r.data.amount) {
      setDone(r.data);
      window.dispatchEvent(new Event("tns:wallet-changed"));
    } else setError(errorOf(r, "We couldn’t add this. Please try again."));
  };

  return (
    <main className="co-page">
      <div className="co-card">
        {done ? (
          <>
            <p className="co-eyebrow">Added to your wallet</p>
            <h1>{naira(done.amount)} is yours</h1>
            <p>Your wallet now has {naira(done.balance)}. Use it on any paper. Wallet money can only be spent on TheNewspaperStand.</p>
            <button type="button" className="co-go" onClick={() => history.push("/")}>Find something to read</button>
          </>
        ) : (
          <>
            <p className="co-eyebrow">{offer && offer.card ? "Gift card" : offer ? "An offer for you" : "Gift cards and codes"}</p>
            <h1>{offer ? `${naira(offer.value)} for your wallet` : "Add a gift card or code"}</h1>
            {offer && !offer.open ? <p className="co-bad" role="alert">{offer.reason}</p> : null}
            {offer && offer.open ? <p>Use it on any paper. {offer.card ? "" : `Ends ${day(offer.endsAt)}.`}</p> : null}
            {!offer && !fromLink ? <p>Type the code on your card. The money goes into your wallet.</p> : null}
            {!offer || offer.open ? (
              <form onSubmit={claim}>
                {!offer ? (
                  <label htmlFor="co-code">Your code
                    <input id="co-code" value={code} maxLength={24} autoCapitalize="characters" autoComplete="off" onChange={(e) => { setCode(e.target.value.toUpperCase()); setError(""); }} placeholder="TNS-XXXX-XXXX" />
                  </label>
                ) : null}
                {error ? <p className="co-bad" role="alert">{error}</p> : null}
                <button type="submit" className="co-go" disabled={busy || !code.trim()}>{busy ? "Adding…" : signedIn ? `Add ${offer ? naira(offer.value) : "to my wallet"}` : "Log in to add it"}</button>
                {!signedIn ? <button type="button" className="co-alt" onClick={() => history.push(`/create_account?next=${next}`)}>New here? Create a free account</button> : null}
              </form>
            ) : null}
            <p className="co-small">Wallet money can only be spent on TheNewspaperStand. It can’t be refunded, withdrawn or sent to someone else.</p>
          </>
        )}
      </div>
    </main>
  );
}
